import { createMockRichText } from '@ecomm/utils'

import type { HowItWorksProps } from '@ecomm/home-landing-data'

export const getHowItWorksMock = async (): Promise<HowItWorksProps> => ({
  __typename: 'ContentfulReviewSection',
  headline: 'Title',
  imageContent: {
    raw: await createMockRichText('image-content-text')
  },
  reviews: [
    {
      review: {
        raw: await createMockRichText('review-content')
      },
      logo: {
        __typename: 'ContentfulAsset',
        contentful_id: '1234',
        description: 'image description',
        file: {
          details: {
            image: {
              height: 1234,
              width: 4567
            },
            size: 1
          },
          url: '/some-url'
        },
        title: 'image title'
      }
    }
  ]
})
